module.exports = __webpack_public_path__ + "static/media/carol80.832eaf4b.png";